import { createFileRoute, redirect } from "@tanstack/react-router";

// Retired as a primary product surface. Managers land on Operations Desk.
// Keep the route registered so old bookmarks redirect cleanly.
export const Route = createFileRoute("/_authenticated/app/dashboard")({
  beforeLoad: () => {
    throw redirect({ to: "/app/operations/desk", replace: true });
  },
});